import Datetime from './Datetime.vue'

// function plugin (Vue) {
//   Vue.component('datetime', Datetime)
// }

Datetime.install = (Vue) => {
    if (Datetime.installed) return;
    Vue.component('datetime', Datetime);
};

// Install by default if using the script tag
// if (typeof window !== 'undefined' && window.Vue) {
//     window.Vue.use(plugin)
// }


const install = function(Vue, opts = {}) {
    /* istanbul ignore if */
    if (install.installed) return;
    Datetime.install(Vue);
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
    // window.VueAmap = VueAMap;
};

export default Datetime
const version = '__VERSION__'

// Export all components too
export {
    Datetime,
    version
}


// WEBPACK FOOTER //
// ./src/shared/libs/vue-datetime/index.js